<script setup>
import SearchResult from '@/components/search/SearchResult.vue';
import LetReadingArea from '@/letapps-vue/components/LetReadingArea.vue';
import { useSearchStore } from '@/stores/searchStore';
import { DxButton, DxDropDownButton } from 'devextreme-vue';
import { DxTextBox } from 'devextreme-vue/text-box';
import { onMounted, ref } from 'vue';
import SearchFilter from './SearchFilter.vue';
import sortIcon from '../letapps-vue/icons/sort2.svg';
import filterIcon from '../letapps-vue/icons/filter2.svg';

const searchStore = useSearchStore();
const searchField = ref();
const searchString = ref(searchStore.searchString);

function doSearch(force = false) {
  searchStore.doSearch(searchString.value, force);
}

onMounted(() => {
  setTimeout(function () {
    searchField.value.instance.focus();
  }, 100);
});

function onClickSort(e) {
  searchStore.sorting = e.itemData.value;
  searchStore.applyFilter();
}

function onClickFilter(e) {
  e.element.blur();
}

function onClickClear(e) {
  e.element.blur();
  searchStore.clearFilter();
}

function clickFeedback(e) {
  e.element.blur();
}
</script>

<template>
  <LetReadingArea sidebredde="max">
    <div class="search-container">
      <div class="new-search-info">
        <p><b>Vi har gjort søgningen på Letguide bedre</b></p>
        <div>
          Du kan nu filtrere dine søgeresultater, og vi har arbejdet med at gøre resultaterne mere
          relevante og lettere at overskue.
        </div>
        <div>
          Oplever du noget, der ikke fungerer som forventet – eller har du input til søgningen?
        </div>
        <div class="feedback-button">
          <a
            href="https://forms.cloud.microsoft/pages/responsepage.aspx?id=bSjZjp4ogki_8ghJx1LIJZprPxw4LotLnbrnihGcxalUQzJPVTVVMkQxV004R1NONTBJWUdPNjhUNS4u&route=shorturl"
            target="_blank"
          >
            <DxButton
              text="Del din feedback her"
              type="default"
              icon="search"
              @click="clickFeedback"
            ></DxButton>
          </a>
        </div>
      </div>
      <div class="search-field-container">
        <DxTextBox
          ref="searchField"
          mode="search"
          v-model="searchString"
          placeholder="Indtast søgekriterie..."
          class="search-field"
          @value-changed="doSearch"
        />
        <DxButton text="Søg" type="default" icon="search" @click="doSearch(true)"></DxButton>
      </div>
    </div>
    <div class="search-result-container">
      <div class="search-filter">
        <div class="filter-heading">
          <DxButton
            text="Filter"
            stylingMode="text"
            :icon="filterIcon"
            :hoverStateEnabled="false"
            :focusStateEnabled="false"
            style="cursor: default"
            @click="onClickFilter"
          ></DxButton>
          <DxButton
            v-if="searchStore.filterActive"
            text="Ryd filter"
            stylingMode="text"
            icon="close"
            @click="onClickClear"
          ></DxButton>
        </div>
        <SearchFilter />
      </div>
      <div class="search-result">
        <div
          class="result-heading"
          :hidden="!searchStore.searchString || searchStore.opslagListe.length === 0"
        >
          <DxDropDownButton
            stylingMode="text"
            :items="[
              { value: 'relevans', text: 'Relevans' },
              { value: 'dato', text: 'Dato' },
            ]"
            :drop-down-options="{ width: 230 }"
            :text="'Sorter efter ' + searchStore.sorting.toLowerCase()"
            :icon="sortIcon"
            @item-click="onClickSort"
          />
        </div>
        <SearchResult :filter="searchStore.searchString" />
      </div>
    </div>
  </LetReadingArea>
</template>

<style scoped lang="scss">
@import '@/css/variables.letguide.scss';

.new-search-info {
  background-color: $letpension-sand;
  padding: 20px;
  margin-bottom: 20px;

  .feedback-button {
    text-align: center;
    margin-top: 20px;
  }
}

.search-result-container {
  display: flex;
  gap: 40px;
}

.search-result {
  flex: 1;
}

.search-filter {
  max-width: 300px;
  padding-top: 36px;
}
.search-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 30px;

  .search-field-container {
    display: flex;
    gap: 20px;
  }

  .search-field {
    width: 600px;
    text-align: right;
  }
}

.filter-heading {
  font-weight: 600;
  margin-bottom: 4px;
}

.result-heading {
  text-align: right;
  margin-bottom: 4px;
}
</style>
